var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-body"},[_c('div',{staticClass:"list"},_vm._l((_vm.magnification),function(item,index){return _c('p',{key:index,staticClass:"item",class:{ active: index == _vm.current },on:{"click":function($event){return _vm.select(index)}}},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }